import { MenuItem } from "primereact/menuitem";
import { isBuyerUserType, isDiversityUserType, isVendorUserType, UserInfo } from "types/v1/security/userAccessTypes";
import { Location } from "react-router-dom";
import RenderHtml from "components/v1/main/structure/RenderHtml";

// Display Functions
export function getActiveIndexBasedOnTabName(menuItems : MenuItem[], tabName : string) {
    for (let i = 0; i < menuItems.length; i++) {
        // Check if menu item label matches tab name
        if (menuItems[i].label?.toLowerCase() === tabName?.toLowerCase()) {
            return i;
        }
    }
    return -1;
}

// Firefox automatically breaks words on slashes (/),
// but Chrome/Edge don't, so it needs to be handled manually
// with the word-break opportunity (<wbr>) tag
export function wordBreakTemplate(text: string, charToBreak: string) {
    const brokenText = text.split(charToBreak);

    const rejoinedText = brokenText.join(charToBreak + "<wbr />");

    return <RenderHtml html={rejoinedText} />;
}

// Common VB6 redirects
export function getVB6SiteOrigin() {
    //return import.meta.env.VITE_VB6_ORIGIN;
    return window.location.origin;
}

export function getVB6DashboardLink(userTypeID: number | undefined) {
    const origin = getVB6SiteOrigin();

    // We don't need to do anything if this undefine
    if (userTypeID !== undefined) {
        if (isVendorUserType(userTypeID)) {
            return origin + "/FrontPage/VendorFrontPage.asp";
        }
        else if (isBuyerUserType(userTypeID)) {
            return origin + "/FrontPage/BuyerFrontPage.asp";
        }
        else if (isDiversityUserType(userTypeID)) {
            return origin + "/FrontPage/StaffFrontPageV2.asp";
        }
    }

    return ""
}

export function getVB6DashboardFullLink(userAccess?: UserInfo) {
    const baseLink = getVB6DashboardLink(userAccess?.userTypeId);
    const xid = getXid();

    // get the correct user page ID based on the userTypeId
    let userPageTypeId = "";
    if (userAccess?.userTypeId !== undefined) {
        if (isVendorUserType(userAccess?.userTypeId)) {
            userPageTypeId = "&VendorID=";
        }
        else if (isBuyerUserType(userAccess?.userTypeId)) {
            userPageTypeId = "&BuyerID=";
        }
        else if (isDiversityUserType(userAccess?.userTypeId)) {
            userPageTypeId = "&DiversityID=";
        }
    };

    return baseLink + "?XID=" + xid + userPageTypeId + userAccess?.companyId;
}

export function getSendMessageLink(userID: number, TID: string, subject: string)
{
    const origin = getVB6SiteOrigin();

    subject = subject.replaceAll(" ", "+"); //replace spaces with + for url formatting
    TID = TID.replaceAll(" ", "+"); //replace spaces with + for url formatting

    return origin + "/Common/Messaging/Messaging/MessageComposeCreate.asp?" + `UID=${userID}&TID=${TID}&Subject=${subject}`;

}

export const buildCustomerSupportLink = (userAccess: UserInfo | undefined) => {
    // Zendesk code for when we're ready
    /*
    let requestType = "";
    if (isDiversityUserType(userAccess?.userTypeId)) {
        requestType = "Staff";
    }
    else if (isVendorUserType(userAccess?.userTypeId)) {
        requestType = "Vendor";
    }
    else {
        return "";
    }

    return `${getVB6SiteOrigin()}/SecureLogin/ZendeskSSO.aspx?UserID=${userAccess?.userId}&RequestType=${requestType}`;
    */
    return getVB6SiteOrigin() + "/Common/Messaging/Messaging/MessagingToB2Gnow.asp";
}

export const buildHelpCenterLink = (requestType: string, userAccess: UserInfo | undefined, curLocation: Location) => {
    const origin = getVB6SiteOrigin();

    // Get module name
    let moduleName = "";
    if (curLocation.pathname.startsWith("/vss/")) {
        moduleName = "fairsource";
    }
    else if (isDiversityUserType(userAccess?.userTypeId)) {
        moduleName = "Staff";
    }
    else if (isVendorUserType(userAccess?.userTypeId)) {
        moduleName = "Vendor";
    }
    else if (isBuyerUserType(userAccess?.userTypeId)) {
        moduleName = "Buyer";
    }
    else {
        return "";
    }

    // Build links
    const helpCenterLink = origin + "/SecureLogin/ZendeskSSO.aspx";
    let zendeskLink = `${helpCenterLink}?UserID=${userAccess?.userId}`;
    if(requestType == "faq") {
        zendeskLink += `&RequestType=${moduleName}FAQ`;
    } else if (requestType == "releaseNotes") {
        zendeskLink += `&RequestType=${moduleName}ReleaseNotes`;
    } else {
        zendeskLink += `&RequestType=${moduleName}`;
    }

    return zendeskLink;
}

export function getXid(): number {
    // random generated number between 1 and 9999 for XID value
    return getRandomInt(1, 9999);
}

export function getRandomInt(min: number, max: number): number {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
}
